export const en = {
    ribbon: {
        new: 'New',
        edit: 'Edit',
        delete: 'Delete',
        download: 'Download',
        import: 'Import',
        view: 'View',
        refresh: 'Refresh',
        validate: 'Validate',
    },
    ui: {
        cancel: 'Cancel',
        saveChanges: 'Save Changes',
        page: 'Page',
        previous: 'Previous',
        next: 'Next',
        entriesPerPage: 'Entries per page',
        entries: 'Entries',
        remove: 'Remove',
        addItem: 'Add Item',
        addNote: 'Add Note',
        addTaxRegistration: 'Add Tax Registration',
        typeToSearch: 'Type to search...',
        applyFilters: 'Apply Filters',
        clearFilters: 'Clear Filters',
        search: 'Search'
    },
    table: {
        invoiceNumber: 'Invoice Number',
        buyerName: 'Buyer Name',
        invoiceDate: 'Invoice Date',
        creationDate: 'Creation Date',
        zugferdVersion: 'ZUGFeRD Version',
        profile: 'Profile',
        fileName: 'File Name',
        noResults: 'No invoices found.'
    },
    modal: {
        editModal: {
            newTitle: 'Create New Invoice',
            editTitle: 'Edit Invoice',
            save: 'Save Changes',
            saveDraft: 'Save Draft',
            saveAndValidate: 'Save & Validate',
            finalizeAndValidate: 'Finalize & Validate',
            modeConvert: 'Convert invoice (PDF)',
            modeCreate: 'Create new invoice',
            cancel: 'Cancel',
        },
        viewModal: {
            title: 'Invoice Details',
            close: 'Close',
        },
        validateModal: {
            title: 'Validation',
            close: 'Close',
            validatorMode: 'Validator',
            requestedMode: 'Requested',
            usedMode: 'Used',
            usedProvider: 'Provider',
            fallbackUsed: 'Fallback to internal validator',
            validateNow: 'Validate again',
            modeAuto: 'Auto (config default)',
            modeKositDaemon: 'Local KoSIT daemon',
            modeServiceBw: 'External Service-BW API',
            modeInternal: 'Local Java validator',
        },
    },
    form: {
        invoiceType: 'Invoice Type',
        internInvoiceType: 'Internal Invoice Type',
        invoiceDetails: 'Invoice Details',
        basicInvoiceInformation: 'Basic Invoice Information',
        invoiceNumber: 'Invoice Number',
        invoiceDate: 'Invoice Date',
        billingPeriodStart: 'Billing Period Start',
        billingPeriodEnd: 'Billing Period End',
        currencyCode: 'Currency Code',
        standardTaxRate: 'Standard Tax Rate',
        taxExemptionReasonCode: 'Tax Exemption Reason Code',
        reducedTaxRate: 'Reduced Tax Rate',
        businessProcess: 'Business Process',

        sellerInformation: 'Seller Information',
        sellerName: 'Seller Name',
        sellerPostcode: 'Postcode',
        sellerCity: 'City',
        sellerStreet: 'Street',
        sellerCountryCode: 'Country Code',
        sellerGlobalID: 'Seller Global ID',
        sellerGlobalIDSchemeIdentifier: 'ID Scheme',
        sellerElectronicAddress: 'Seller Electronic Address',
        sellerContact: 'Seller Contact',
        sellerTaxRegistration: 'Seller Tax Registration',

        buyerInformation: 'Buyer Information',
        buyerName: 'Buyer Name',
        buyerPostcode: 'Postcode',
        buyerCity: 'City',
        buyerStreet: 'Street',
        buyerCountryCode: 'Country Code',
        buyerGlobalID: 'Buyer Global ID',
        buyerGlobalIDSchemeIdentifier: 'ID Scheme',
        buyerElectronicAddress: 'Buyer Electronic Address',
        buyerReference: 'Buyer Reference',
        buyerContact: 'Buyer Contact',
        buyerTaxRegistration: 'Buyer Tax Registration',

        bankAndPaymentInformation: 'Bank and Payment Information',
        iban: 'IBAN',
        bic: 'BIC',
        bankName: 'Bank Name',
        paymentTerms: 'Payment Terms',

        tradeLineItems: 'Trade Line Items',
        itemName: 'Item Name',
        unitCode: 'Unit Code',
        netUnitPrice: 'Unit Price',
        billedQuantity: 'Quantity',
        sellerAssignedId: 'Seller Assigned ID',
        globalID: 'Global ID',
        grossPrice: 'Gross Price',
        categoryCode: 'Category Code',
        netPrice: 'Net Price',
        taxPercent: 'Tax',

        totalNet: 'Total Net',
        totalTax: 'Total Tax',
        totalGross: 'Total Gross',

        notes: 'Notes',
        noteContent: 'Note Content',
        noteSubjectCode: 'Note Subject Code',

        taxRegNo: 'Tax Registration Number',
        taxSchemeId: 'Tax Scheme ID',

        contactName: 'Name',
        contactOrgUnit: 'Organization Unit',
        contactEmail: 'Email Address',
        contactPhone: 'Phone Number'
    },
    tooltips: {
        // UX tooltips
        useDefaultValues: "use Default Values",
        // General tooltips
        invoiceType: "Here you can see the selected invoice type.",
        invoiceNumber: "Enter the unique invoice number here.",
        invoiceDate: "Select the date the invoice was issued.",
        invoiceStartDate: "The date when the billing period starts.",
        invoiceEndDate: "The date when the billing period ends.",
        currencyCode: "Select the currency in which all invoice amounts are specified.",
        standardTaxRate: "The VAT rate applicable to the invoiced item, given as a percentage.",
        reducedTaxRate: "The VAT rate given as a percentage applicable to the relevant VAT category.",

        // Seller tooltips
        sellerName: "Enter the seller's name as registered in the commercial register.",
        sellerPostcode: "Enter the postal code of the seller's address.",
        sellerCity: "Enter the city of the seller's address.",
        sellerStreet: "Enter the street and house number of the seller's address.",
        sellerCountryCode: "Select the country of the seller's address.",
        sellerGlobalID: "An identifier of the seller (typically assigned by the acquirer), such as the creditor number for the funds management procedure or the supplier number for the ordering system.",
        sellerElectronicAddress: "Specifies an electronic address of the seller to which an application-level response to an invoice can be sent.",
        sellerPaymentAccountName : "Name of the account at a payment service provider to which the payment should be made. (e.g. account holder)",

        // Buyer tooltips (added, analogous to seller)
        buyerName: "Enter the buyer's name as registered in the commercial register.",
        buyerPostcode: "Enter the postal code of the buyer's address.",
        buyerCity: "Enter the city of the buyer's address.",
        buyerStreet: "Enter the street and house number of the buyer's address.",
        buyerCountryCode: "Select the country of the buyer's address.",
        buyerGlobalID: "An identifier of the buyer (typically assigned by the seller), such as the debtor number for accounting or the customer number for order management.",
        buyerElectronicAddress: "Specifies an electronic address of the buyer to which an invoice should be sent.",
        buyerReference: "An identifier assigned by the buyer and used for internal control purposes.",
        buyerContact: "Enter the buyer's contact information.",

        iban: "Enter the recipient's IBAN.",
        bic: "Enter the bank's BIC.",
        paymentTerms: "Select one of the payment methods.",
        tradeLineItems: "Enter the line item number of the invoice.",

        contactSellerName: "Enter the contact person's name for inquiries.",
        contactSellerEmail: "Enter the contact person's email address.",
        contactSellerPhone: "Enter the contact person's phone number.",

        // Buyer contact tooltips are already there, but we'll leave them as is
        contactBuyerName: "Enter the contact person's name for inquiries.",
        contactBuyerEmail: "Enter the contact person's email address.",
        contactBuyerPhone: "Enter the contact person's phone number.",

        //Trade Line Items
        itemName: "Enter the name of the invoiced item.",
        unitCode: "Select the unit of the invoiced item.",
        netUnitPrice: "Enter the unit price of the item excluding VAT.",
        billedQuantity: "Enter the quantity of the invoiced item.",
        sellerTaxRegNo: "Enter the VAT ID or tax number of the seller.",
        buyerTaxRegNo: "Enter the VAT ID or tax number of the buyer.",
        tradeLineTax: "Enter the tax rate of the invoice line item.",
        categoryCode: "Invoiced item VAT category code.",
        globalID: "An item identifier based on a registered schema.",
        sellerAssignedId: "An identifier assigned to the item by the seller.",
        netPrice: "The total amount of the invoice line item. This is the amount without VAT, but including any discounts and charges applicable to the invoice line item, as well as any other taxes due.",
        //TLI Summary
        totalNet: "The total amount of the invoice without VAT.",
        totalTax: "The total amount of VAT for the invoice.",
        totalGross: "The total amount of the invoice including VAT.",

        // Note tooltips
        noteContent: "A text note containing unstructured information relevant to the invoice as a whole. If necessary, information on the storage obligation pursuant to § 14 para. 4 no. 9 UStG can be included here.",
        noteSubjectCode: "The subject for the subsequent text note on the invoice."
    }
};

export const de = {
    ribbon: {
        new: 'Neu',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        download: 'Herunterladen',
        import: 'Importieren',
        view: 'Anzeigen',
        refresh: 'Aktualisieren',
        validate: 'Validieren',
    },
    ui: {
        page: 'Seite',
        previous: 'Zurück',
        next: 'Weiter',
        entriesPerPage: 'Einträge pro Seite',
        entries: 'Einträge',
        remove: 'Entfernen',
        addItem: 'Artikel hinzufügen',
        addNote: 'Notiz hinzufügen',
        addTaxRegistration: 'Steuerregistrierung hinzufügen',
        typeToSearch: 'Zum Suchen tippen...',
        applyFilters: 'Filter anwenden',
        clearFilters: 'Filter löschen',
        search: 'Suche'
    },
    table: {
        invoiceNumber: 'Rechnungsnummer',
        buyerName: 'Käufername',
        invoiceDate: 'Rechnungsdatum',
        creationDate: 'Erstellungsdatum',
        zugferdVersion: 'ZUGFeRD Version',
        profile: 'Profil',
        fileName: 'Dateiname',
        noResults: 'Es wurden keine Rechnungen gefunden.'
    },
    modal: {
        editModal: {
            newTitle: 'Neue Rechnung erstellen',
            editTitle: 'Rechnung bearbeiten',
            save: 'Änderungen speichern',
            saveDraft: 'Entwurf speichern',
            saveAndValidate: 'Speichern & Validieren',
            finalizeAndValidate: 'Finalisieren & validieren',
            modeConvert: 'Rechnung konvertieren (PDF)',
            modeCreate: 'Neue Rechnung erstellen',
            cancel: 'Abbrechen',
        },
        viewModal: {
            title: 'Rechnungsdetails',
            close: 'Schließen',
        },
        validateModal: {
            title: 'Validierung',
            close: 'Schließen',
            validatorMode: 'Validator',
            requestedMode: 'Angefordert',
            usedMode: 'Verwendet',
            usedProvider: 'Quelle',
            fallbackUsed: 'Fallback auf internen Validator',
            validateNow: 'Erneut validieren',
            modeAuto: 'Auto (Konfigurationsstandard)',
            modeKositDaemon: 'Lokaler KoSIT-Daemon',
            modeServiceBw: 'Externe Service-BW-API',
            modeInternal: 'Lokaler Java-Validator',
        },
    },
    form: {
        invoiceType: 'Rechnungsart',
        internInvoiceType: 'Interne Rechnungsart',
        invoiceDetails: 'Rechnungsdetails',
        basicInvoiceInformation: 'Grundlegende Rechnungsinformationen',
        invoiceNumber: 'Rechnungsnummer',
        invoiceDate: 'Rechnungsdatum',
        billingPeriodStart: 'Rechnungszeitraum Start',
        billingPeriodEnd: 'Rechnungszeitraum Ende',
        currencyCode: 'Währungscode',
        standardTaxRate: 'Standardsteuersatz',
        taxExemptionReasonCode: 'Steuerbefreiungsgrund Code',
        reducedTaxRate: 'Ermäßigter Steuersatz',
        businessProcess: 'Geschäftsprozess',

        sellerInformation: 'Verkäuferinformationen',
        sellerName: 'Name des Verkäufers',
        sellerPostcode: 'Postleitzahl',
        sellerCity: 'Stadt',
        sellerStreet: 'Straße',
        sellerCountryCode: 'Ländercode',
        sellerGlobalID: 'Globale Verkäufer-ID',
        sellerGlobalIDSchemeIdentifier: 'ID Schema',
        sellerElectronicAddress: 'Elektronische Adresse des Verkäufers',
        sellerContact: 'Verkäuferkontakt',
        sellerTaxRegistration: 'Steuerregistrierung des Verkäufers',

        buyerInformation: 'Käuferinformationen',
        buyerName: 'Name des Käufers',
        buyerPostcode: 'Postleitzahl',
        buyerCity: 'Stadt',
        buyerStreet: 'Straße',
        buyerCountryCode: 'Ländercode',
        buyerGlobalID: 'Globale Käufer-ID',
        buyerGlobalIDSchemeIdentifier: 'ID Schema',
        buyerElectronicAddress: 'Elektronische Adresse des Käufers',
        buyerReference: 'Käuferreferenz',
        buyerContact: 'Käuferkontakt',
        buyerTaxRegistration: 'Steuerregistrierung des Käufers',

        bankAndPaymentInformation: 'Bank- und Zahlungsinformationen',
        iban: 'IBAN',
        bic: 'BIC',
        bankName: 'Bankname',
        paymentTerms: 'Zahlungsbedingungen',

        tradeLineItems: 'Handelspositionen',
        itemName: 'Artikelname',
        unitCode: 'Mengeneinheit',
        netUnitPrice: 'Stückpreis',
        billedQuantity: 'Menge',
        sellerAssignedId: 'Verkäufer zugewiesene ID',
        globalID: 'Globale ID',
        grossPrice: 'Bruttopreis',
        categoryCode: 'Kategoriecode',
        netPrice: 'Nettopreis',
        taxPercent: 'Steuersatz',

        totalNet: 'Gesamtbetrag netto',
        totalTax: 'Gesamtbetrag steuer',
        totalGross: 'Gesamtbetrag brutto',

        notes: 'Notizen',
        noteContent: 'Notizinhalt',
        noteSubjectCode: 'Notizfachcode',

        taxRegNo: 'Steuerregistrierungsnummer',
        taxSchemeId: 'Steuerschema-ID',

        contactName: 'Name',
        contactOrgUnit: 'Organisationseinheit',
        contactEmail: 'E-Mail-Adresse',
        contactPhone: 'Telefonnummer'
    },
    tooltips: {
        // UX tooltips
        useDefaultValues: "Standardwerte verwenden",
        // General tooltips
        invoiceType: "Hier sehen Sie die ausgewählte Rechnungsart.",
        invoiceNumber: "Geben Sie hier die eindeutige Rechnungsnummer ein.",
        invoiceDate: "Wählen Sie das Ausstellungsdatum der Rechnung aus.",
        invoiceStartDate: "Das Datum, an dem der Abrechnungszeitraum beginnt.",
        invoiceEndDate: "Das Datum, an dem der Abrechnungszeitraum endet.",
        currencyCode: "Wählen Sie die Währung aus, in der alle Rechnungsbeträge angegeben sind.",
        standardTaxRate: "Der für den in Rechnung gestellten Posten geltende und als Prozentsatz angegebene Umsatzsteuersatz.",
        reducedTaxRate: "Der Umsatzsteuersatz, angegeben als für die betreffende Umsatzsteuerkategorie geltender Prozentsatz.",

        // Seller tooltips
        sellerName: "Geben Sie den Namen des Verkäufers gemäß Handelsregister ein.",
        sellerPostcode: "Geben Sie die Postleitzahl der Verkäuferadresse ein.",
        sellerCity: "Geben Sie die Stadt der Verkäuferadresse ein.",
        sellerStreet: "Geben Sie Straße und Hausnummer der Verkäuferadresse ein.",
        sellerCountryCode: "Wählen Sie das Land der Verkäuferadresse aus.",
        sellerGlobalID: "Eine (i. d. R. vom Erwerber vergebene) Kennung des Verkäufers, wie z. B. die Kreditorennummer für das Mittelbewirtschaftungsverfahren oder die Lieferantennummer für das Bestellsystem.",
        sellerElectronicAddress: "Gibt die elektronische Adresse des Verkäufers an, an die die Antwort der Anwendungsebene auf eine Rechnung gesendet werden kann.",
        sellerPaymentAccountName : "Name des Kontos bei einem Zahlungsdienstleister, auf das die Zahlung erfolgen soll. (z. B. Kontoinhaber)",

        // Buyer tooltips (neu hinzugefügt, analog zu Verkäufer)
        buyerName: "Geben Sie den Namen des Käufers gemäß Handelsregister ein.",
        buyerPostcode: "Geben Sie die Postleitzahl der Käuferadresse ein.",
        buyerCity: "Geben Sie die Stadt der Käuferadresse ein.",
        buyerStreet: "Geben Sie Straße und Hausnummer der Käuferadresse ein.",
        buyerCountryCode: "Wählen Sie das Land der Käuferadresse aus.",
        buyerGlobalID: "Eine (i. d. R. vom Verkäufer vergebene) Kennung des Erwerbers, wie z. B. die Debitorennummer für die Buchhaltung oder die Kundennnummer für die Auftragsverwaltung.",
        buyerElectronicAddress: "Gibt eine elektronische Adresse des Erwerbers an, an die eine Rechnung gesendet werden sollte.",
        buyerReference: "Ein vom Erwerber zugewiesener und für interne Lenkungszwecke benutzter Bezeichner.",
        buyerContact: "Geben Sie die Käuferkontaktinformationen ein.",

        iban: "Geben Sie die IBAN des Empfängers ein.",
        bic: "Geben Sie den BIC der Bank ein.",
        paymentTerms: "Wählen Sie eine der Zahlungsmethoden aus.",
        tradeLineItems: "Geben Sie die Positionsnummer des Rechnungspostens ein.",

        contactSellerName: "Geben Sie den Namen der Kontaktperson für Anfragen ein.",
        contactSellerEmail: "Geben Sie die E-Mail-Adresse der Kontaktperson ein.",
        contactSellerPhone: "Geben Sie die Telefonnummer der Kontaktperson ein.",

        contactBuyerName: "Geben Sie den Namen der Kontaktperson für Anfragen ein.",
        contactBuyerEmail: "Geben Sie die E-Mail-Adresse der Kontaktperson ein.",
        contactBuyerPhone: "Geben Sie die Telefonnummer der Kontaktperson ein.",

        //Trade Line Items
        itemName: "Geben Sie den Namen des in Rechnung gestellten Artikels ein.",
        unitCode: "Wählen Sie die Mengeneinheit des in Rechnung gestellten Artikels aus.",
        netUnitPrice: "Geben Sie den Nettostückpreis des Artikels (ohne MwSt.) ein.",
        billedQuantity: "Geben Sie die Menge des in Rechnung gestellten Artikels ein.",
        sellerTaxRegNo: "Geben Sie die Umsatzsteuer-Identifikationsnummer oder die Steuernummer des Verkäufers ein.",
        buyerTaxRegNo: "Geben Sie die Umsatzsteuer-Identifikationsnummer oder die Steuernummer des Käufers ein.",
        tradeLineTax: "Geben Sie den Steuersatz des Rechnungspostens ein.",
        categoryCode: "Kategoriecode des in Rechnung gestellten Artikels.",
        globalID: "Eine auf einem registrierten Schema basierende Postenkennung.",
        sellerAssignedId: " Eine dem Posten vom Verkäufer zugewiesene Kennung.",
        netPrice: "Der Gesamtbetrag der Rechnungsposition. Dies ist der Betrag ohne Umsatzsteuer, aber einschließlich aller für die Rechnungsposition geltenden Nachlässe und Abgaben sowie sonstiger anfallender Steuern.",
        //TLI Summary
        totalNet: "Der Gesamtbetrag der Rechnung ohne Umsatzsteuer.",
        totalTax: "Der Gesamtbetrag der Umsatzsteuer für die Rechnung.",
        totalGross: " Der Gesamtbetrag der Rechnung mit Umsatzsteuer.",


        noteContent: "Ein Textvermerk, der unstrukturierte Informationen enthält, die für die Rechnung als Ganzes maßgeblich sind. Erforderlichenfalls können Angaben zur Aufbewahrungspflicht gem. § 14 Abs. 4 Nr. 9 UStG hier aufgenommen werden.",
        noteSubjectCode: "Der Betreff für den nachfolgenden Textvermerk zur Rechnung."
    }
};
